import React from 'react'

function BooleanCellDisplayRenderer(record, row) {
  if (record[row.key]) {
    return (<b>Yes</b>)
  }
  return (<span>No</span>)
}

export default BooleanCellDisplayRenderer
